<template>
	<el-dialog
		title="Add Non-coverage Activities"
		:visible.sync="updateSectionActivity"
		width="95%"
		top="0"
		custom-class="nonCovEditModal"
		:lock-scroll="true"
		:show-close="true"
	>
		<el-row :gutter="20" class="mb-3">
			<el-col :span="24">
				<div style="display: flex; justify-content: space-between" class="mb-2">
					<h2 class="popup-title">Add/Edit <q>{{ edit_select_non_coverage_activity.activity_name ? edit_select_non_coverage_activity.activity_name : 'Activity' }}</q></h2>
					<!-- <el-button
						icon="el-icon-close"
						size="small"
						circle
						@click="updateSectionActivity = false; resetSelectedNonCoverageActivity();"
					></el-button> -->
                    <span class="cursor-pointer" style="font-size: 28px; color: #333;" @click="updateSectionActivity = false;">
						<i class="el-icon-circle-close"></i>
					</span>
				</div>
			</el-col>
		</el-row>

		<el-row :gutter="20" class="my-3">
			<el-col :span="24" class="text-right">
				<!-- <el-button type="warning" plain icon="el-icon-alarm-clock" class="primary-settings-button" size="small" @click="openHourlyView">
                    View Hourly
                </el-button> -->
			</el-col>
		</el-row>

		<!-- <el-row :gutter="20">
			<el-col :span="24">
				<div class="flex items-center mb-2">
					<div class="py-2">
						<p class="top-filter-label py-1">Section</p>
						<el-select
							:value="edit_select_non_coverage_activity.store_section ? Number(edit_select_non_coverage_activity.store_section) : null"
							filterable
							style="max-width: 200px"
                            size="small"
							placeholder="Select Section"
						>
							<el-option
								v-for="(section, sectionIndex) in sections"
								:key="'section-' + sectionIndex"
								:value="section.id"
								:label="section.name"
							></el-option>
						</el-select>
					</div>

					<div class="py-2 ml-4">
						<p class="top-filter-label py-1">Station</p>
						<el-select
							:value="edit_select_non_coverage_activity.function"
							filterable
							style="max-width: 200px"
                            size="small"
							placeholder="Select Station"
						>
							<el-option
								v-for="(func, index5) in storeFunctions"
								:key="index5"
								:value="func.id"
								:label="func.function"
							>
								{{ func.function }}
							</el-option>
						</el-select>
					</div>
				</div>
			</el-col>
		</el-row> -->

        <el-row :gutter="20">
            <el-col :span="24">
                <div style="vertical-align: middle; max-height: 470px; overflow-y: auto; padding: 0 10px;">
                    <el-row v-for="(activityAction, actionIndex) in edit_select_non_coverage_activity.actions" :key="'activity-action-'+actionIndex" :gutter="20" class="mb-1">
                        <el-col :span="24">
                            <el-row v-if="actionIndex == 0" :gutter="20" class="mb-2 custom-table__header">
                                <el-col :span="3">
                                    <h4 class="text-center">Frequency</h4>
                                </el-col>
                                <el-col :span="3">
                                    <h4 class="text-center">Plan By</h4>
                                </el-col>
                                <el-col v-if="edit_select_non_coverage_activity.plan_by === 'duration'" :span="4">
                                    <h4 class="text-center">Duration (HH:mm)</h4>
                                </el-col>
                                <el-col v-if="edit_select_non_coverage_activity.plan_by !== 'duration'" :span="3">
                                    <h4 class="text-center">People</h4>
                                </el-col>
                                <el-col v-if="edit_select_non_coverage_activity.plan_by !== 'duration'" :span="6">
                                    <h4 class="text-center">Time</h4>
                                </el-col>
                                <el-col :span="edit_select_non_coverage_activity.plan_by === 'no_of_people' && edit_select_non_coverage_activity.editable ? 4 : 3">
                                    <h4 v-if="edit_select_non_coverage_activity.frequency !== 'monthly'" class="text-center">Days</h4>
                                    <h4 v-if="edit_select_non_coverage_activity.frequency === 'monthly'" class="text-center">Months</h4>
                                </el-col>
                                <el-col :span="1">&nbsp;</el-col>
                            </el-row>

                            <el-row :gutter="20" class="custom-table__body">
                                <el-col v-if="actionIndex == 0" :span="3" class="text-center">
                                    <el-select
                                        v-model="edit_select_non_coverage_activity.frequency"
                                        filterable
                                        style="max-width: 240px"
                                        size="small"
                                        placeholder="Frequency"
                                    >
                                        <el-option
                                            value="hourly"
                                            label="Hourly"
                                        ></el-option>
                                        <el-option
                                            value="daily"
                                            label="Daily"
                                        ></el-option>
                                        <el-option
                                            value="weekly"
                                            label="Weekly"
                                        ></el-option>
                                        <el-option
                                            value="monthly"
                                            label="Monthly"
                                        ></el-option>
                                    </el-select>
                                    <span v-if="validationError && !edit_select_non_coverage_activity.frequency" class="validation-error-msg">Frequency is required</span>
                                </el-col>
                                <el-col v-else-if="actionIndex > 0" :span="3" class="text-center">
                                    &nbsp;
                                </el-col>
                                <el-col :span="3" class="text-center">
                                    <el-select v-model="activityAction.plan_by" v-validate="'required'"
                                        name="plan_by"  placeholder="Select plan" size="small" style="width: 100%;" @change="changePlanBy(activityAction.plan_by)">
                                        <el-option value="no_of_people" label="No. of people"></el-option>
                                        <el-option value="duration" label="Duration"></el-option>
                                    </el-select>
                                    <span v-if="validationError && !activityAction.plan_by" class="validation-error-msg">Plan by is required</span>
                                </el-col>
                                <el-col v-if="edit_select_non_coverage_activity.plan_by === 'duration'" :span="4" class="text-center">
                                    <el-select v-model="activityAction.duration_hrs" :disabled="activityAction.plan_by !== 'duration'"  style="width: 45%; margin-right: 2px"  filterable placeholder="HH"
                                        size="mini"
                                        @change="durationChanged(actionIndex)">
                                        <el-option :value="0" :label="'00'"></el-option>
                                        <el-option v-for="(hour, hour_index) in generateMins(25)"
                                            :key="hour_index" :value="hour"
                                            :label="hour < 10 ? ('0'+hour) : hour">
                                        </el-option>
                                    </el-select>
                                    <span style="padding-right:2px">:</span>
                                    <el-select v-model="activityAction.duration_mins" :disabled="activityAction.plan_by !== 'duration' || activityAction.duration_hrs == 24"   style="width: 45%;" filterable placeholder="MM"
                                        size="mini"
                                        @change="durationChanged(actionIndex)">
                                        <el-option :value="0" :label="'00'"></el-option>
                                        <el-option v-for="(min, min_index) in generateMins(60)"
                                            :key="min_index" :value="min"
                                            :label="min < 10 ? ('0'+min) : min">
                                        </el-option>
                                    </el-select>
                                    <span v-if="validationError && !activityAction.duration_hrs && !activityAction.duration_mins" class="validation-error-msg">Duration is required</span>
                                </el-col>
                                <el-col v-if="edit_select_non_coverage_activity.plan_by !== 'duration'" :span="3">
                                    <el-input-number  v-model="activityAction.number_of_people" :disabled="activityAction.plan_by !== 'no_of_people'"  size="mini" controls-position="right" style="width: 100%" :min="1" :max="50"></el-input-number>
                                    <span v-if="validationError && !activityAction.number_of_people" class="validation-error-msg">No of people is required</span>
                                </el-col>
                                <el-col v-if="edit_select_non_coverage_activity.plan_by !== 'duration'" :span="6" class="text-center" style="padding-left: 0;padding-right: 0;">
                                    <div v-for="(itemTimeValue, itemTimeIndex) in activityAction.selected_time_units" :key="'time-elements-'+itemTimeIndex">
                                        <el-time-select
                                            v-model="itemTimeValue.start_time"
                                            v-validate="edit_select_non_coverage_activity.plan_by !== 'duration' ? 'required' : ''"
                                            style="width: 35%; margin-right: 8px"
                                            :picker-options="{
                                                start: '00:00',
                                                step: '00:30',
                                                end: '23:30',
                                            }"
                                            size="mini"
                                            placeholder="Select time"
                                        >
                                        </el-time-select>
                                        <el-time-select
                                            v-model="itemTimeValue.end_time"
                                            style="width: 35%; margin-right: 8px"
                                            :picker-options="{
                                                start: '00:00',
                                                step: '00:30',
                                                end: '23:30',
                                            }"
                                            size="mini"
                                            placeholder="Select time"
                                        >
                                        </el-time-select>
                                        <img
                                            v-if="activityAction.selected_time_units.length > 1"
                                            src="../../../../../assets/icons/trash-icon.svg"
                                            class="ml-2 cursor-pointer"
                                            width="12"
                                            alt="delete"
                                            @click="$delete(activityAction.selected_time_units, itemTimeIndex)"
                                        />
                                        <span v-if="validationError && (!itemTimeValue.start_time || !itemTimeValue.end_time)" class="validation-error-msg pt-1">Start and end time is required</span>
                                        <div class="w-100 pt-1"></div>
                                    </div>
                                    <div class="text-left ns-add-icon-pl pt-1">
                                        <i class="el-icon-circle-plus-outline cursor-pointer default-icon mb-2" @click="addNewTimeSlot(actionIndex)"></i>
                                    </div>
                                </el-col>
                                <el-col :span="3" class="text-center">
                                    <el-select
                                        v-if="edit_select_non_coverage_activity.frequency !== 'monthly'"
                                        v-model="activityAction.weekly_freq"
                                        multiple
                                        collapse-tags
                                        filterable
                                        size="mini"
                                        style="width: 100%"
                                        :disabled="edit_select_non_coverage_activity.frequency == 'daily'"
                                        @change="$event => {if($event.includes('all')) { activityAction.weekly_freq = daysList.filter(el => el.value == 'all').map(el => el.value) }}"
                                        >
                                        <el-option
                                            v-for="(dayItem, dayIndex) in daysList"
                                            :key="'day-index-'+dayIndex"
                                            :value="dayItem.value"
                                            :label="dayItem.label"
                                            :disabled="activityAction.weekly_freq.includes('all') && dayItem.value != 'all'"
                                        ></el-option>
                                    </el-select>
                                    <el-select v-if="edit_select_non_coverage_activity.frequency === 'monthly'"  v-model="activityAction.monthly_freq" multiple collapse-tags filterable size="mini" style="width: 100%">
                                        <el-option v-for="(monthItem, monthIndex) in generateMins(32)" :key="'day-index-'+monthIndex" :value="monthItem" :label="monthItem"></el-option>
                                    </el-select>
                                    <span v-if="validationError && edit_select_non_coverage_activity.frequency !== 'daily' && edit_select_non_coverage_activity.frequency !== 'monthly' && !activityAction.weekly_freq.length" class="validation-error-msg pt-1">Days are required</span>
                                    <span v-else-if="validationError && edit_select_non_coverage_activity.frequency == 'monthly' && !activityAction.monthly_freq.length" class="validation-error-msg pt-1">Month dates are required</span>
                                </el-col>
                                <el-col :span="1" style="padding-top: 4px;">
                                    <i class="el-icon-circle-close cursor-pointer default-icon" @click="deleteTimeSlot(actionIndex)"></i>
                                </el-col>
                            </el-row>
                        </el-col>
                    </el-row>
                </div>
                <div style="padding: 0 10px; margin-top: 15px;">
                    <el-row :gutter="20" class="mb-2">
                        <el-col :span="24" class="text-left">
                            <span class="cursor-pointer" style="color: #e29d5a;" @click="addNewRowTime">
                                &nbsp;<i class="el-icon-circle-plus-outline"></i>&nbsp;Add More
                            </span>
                        </el-col>
                    </el-row>
                </div>
            </el-col>
        </el-row>
        <span slot="footer" class="dialog-footer">
            <el-button type="warning" round size="small" class="primary-settings-button__save" @click="saveDailyActivities">Save</el-button>
        </span>
	</el-dialog>
</template>

<script>
import settingsMixin from "../../../../../../mixins/settingsMixin";
import { EventBus } from "../../../../../eventBus";
export default {
	name: "AddOrEditNonCoverageActivity",
	mixins: [settingsMixin],
    data() {
        return {
            validationError: false
        };
    },
    mounted() {
        const self = this;
        EventBus.$on('nonCoverageActivityValidated', function(payload) {
            self.validationError = !payload;
        });
    },
    beforeDestroy() {
        EventBus.$off('nonCoverageActivityValidated');
    }
};
</script>

<style lang="scss">
.nonCovEditModal {
    position: absolute;
    right: 0;
    margin: 0;
    height: 100vh;
    overflow-y: auto;
    .el-dialog__header {
        display: none;
    }
    .popup-title {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        line-height: 33px;
        text-transform: capitalize;
        color: #000000;
    }
    .custom-cell-padding {
        padding-right: 5px !important;
        padding-left: 5px !important;
    }
    .custom-cell-heading {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 10px;
        line-height: 19px;
        color: #333333;
        text-align: center;
    }
    .custom-cell-label {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 12px;
        line-height: 22px;
        color: #666666;
    }
    .is-active-label {
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 600;
        font-size: 12px;
        line-height: 19px;
        color: #F9A168;
    }
    .day-tag.is-active {
        color: #F9A168;
        background: #FFF9F4;
        border-radius: 50%;
        padding: 4px;
        padding-top: 10px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        text-transform: capitalize;
        border: 1px solid #F9A168;
        margin-bottom: 4px;
        margin-right: 4px;
        height: 42px;
        width: 42px;
        display: inline-block;
        .inner-tag-text {
            text-align: center;
        }
    }
    .day-tag.is-inactive {
        color: #666666;
        background: #FFFFFF;
        border-radius: 50%;
        padding: 4px;
        padding-top: 10px;
        font-family: 'Open Sans';
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 19px;
        text-align: center;
        text-transform: capitalize;
        border: 1px solid #EAEBED;
        margin-bottom: 4px;
        margin-right: 4px;
        height: 42px;
        width: 42px;
        display: inline-block;
        .inner-tag-text {
            text-align: center;
        }
    }
    .top-filter-label {
        font-weight: 600;
        font-size: 14px;
        line-height: 19px;
        color: #333333;
    }
    .el-dialog__body {
        height: 90% !important;
        overflow-y: auto;
        padding: 40px;
        padding-bottom: 0 !important;
    }
    .el-dialog__footer {
        padding: 0 40px;
    }

    .custom-table__header {
        border: 1px solid #e4e4f6;
        background: #f4f4f4;
        padding: 10px;
    }
    .custom-table__body {
        border-bottom: 1px solid #e4e4f6;
        /* background: #fffcfc; */
				background: #ffffff;
        padding: 10px;
    }
    .ns-add-icon-pl{
        padding-left: 55px;
    }
    .validation-error-msg {
        color: red;
        font-size: 12px;
        font-weight: 400;
        display: block;
        padding-top: 4px;
        text-align: center;
    }
}
</style>
